import { persistedDataIsFilled } from 'components/cef_form/PostcodeSelector/postcodeSelectorUtils';

export const initialState = (addressOne, addressTwo) => ({
  postcodeSearched: {
    manualCompanyPostcodeSearched: false,
    billingPostcodeSearched: false,
    homePostcodeSearched: false,
    previousPostcodeSearched: false,
  },
  postcodeIsReset: {
    manualCompanyPostcodeIsReset: false,
    billingPostcodeIsReset: false,
    homePostcodeIsReset: false,
    previousPostcodeIsReset: false,
  },
  hasPersistedData: {
    manualCompanyHasPersistedData: persistedDataIsFilled(addressOne),
    billingHasPersistedData: persistedDataIsFilled(addressTwo),
  },
  addressIsDuplicated: false,
});

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_POSTCODE_SEARCHED':
      return {
        ...state,
        postcodeSearched: {
          ...state.postcodeSearched,
          [action.payload.field]: action.payload.value,
        },
      };
    case 'SET_POSTCODE_IS_RESET':
      return {
        ...state,
        postcodeIsReset: {
          ...state.postcodeIsReset,
          [action.payload.field]: action.payload.value,
        },
      };
    case 'SET_PERSISTED_DATA':
      return {
        ...state,
        hasPersistedData: {
          ...state.hasPersistedData,
          [action.payload.field]: action.payload.value,
        },
      };
    case 'SET_ADDRESS_DUPLICATED':
      return {
        ...state,
        addressIsDuplicated: action.payload,
      };
    default:
      return state;
  }
};
